module.exports = __webpack_public_path__ + "img/tuihuanma.6bca02b4.png";